// extracted by mini-css-extract-plugin
export var closeButton = "notificationBar-module--closeButton--97851";
export var notificationBar = "notificationBar-module--notificationBar--be64c";